import React from 'react';
//import './App.css';
import Countdown from './Countdown';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Countdown />
      </header>
    </div>
  );
}

export default App;
